import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { sweetAlert } from "../../Common/Utills/Utills";

//   import UpdatePartyName from "./UpdatePartyName";
import moment from "moment";
import Swal from "sweetalert2";
import Pagination from "../../Common/Pagination/Pagination";
import { CSSTransition } from "react-transition-group";
import AddGovtRateList from "./AddGovtRateList";
import UpdateGovtRateList from "./UpdateGovtRateList";
import _ from "lodash";

const GovtRateList = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setSelectedRowsData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showSearch, setShowSearch] = useState(false);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [discom, setDiscom] = useState([]);
  const [discomId, setDiscomId] = useState("");
  const [region, setRegion] = useState([]);
  const [regionId, setRegionId] = useState("");

  const formRef = useRef(null);
  // console.log("rowData", rowAddData)

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };
  const toggleSearch = () => {
    setShowSearch(!showSearch); // Toggle the state to show/hide search input field
  };

  // Add a function to handle page size change
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const [filterCriteria, setfilterCriteria] = useState({
    circle_name: "",
  });

  const handleFilterChange = (name, value) => {
    setfilterCriteria((prevFilterCriteria) => {
      return {
        ...prevFilterCriteria,
        [name]: value,
      };
    });
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setSelectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const getData = async () => {
    let BASE_URL = SERVER_URL + `/api/govt-rate/all-govt-rate-list/${user_id}`;
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );
    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(result.data);
    } else {
      setRowData([]);
    }
  };

  useEffect(() => {
    const fecthDebounced = _.debounce(getData, 500);
    fecthDebounced();
    return () => {
      fecthDebounced.cancel();
    };
  }, [currentPage, pageSize, filterCriteria]);
  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
    // setRowData((prevData) =>
    //   prevData.map((row) => (row === params.data ? updatedData : row))
    // );
    // console.log("Updated data:", updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
  }, []);

  const deleteRow = async (id) => {
    const message = "Are you want to delete this govt circle rate!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL = SERVER_URL + `/api/govt-rate/govt-rate-list/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
          // Retain the existing filter criteria values
        };
      });
      getData();
    } else {
      toast.error(response.message);
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
          // Retain the existing filter criteria values
        };
      });
      getData();
    }
  };

  const addDataToModal = async (rowData) => {
    setSelectedRowsData(rowData);
  };

  const handleDiscomChange = (e) => {
    const discomId = e.target.value !== "" ? parseInt(e.target.value) : "";

    setDiscomId(discomId ? discomId : "");
    setRegion([]);
    setRegionId("");

    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      discom_id: discomId,
      region_id: "",
    }));
  };

  const handleRegionChange = (e) => {
    const regionId = e.target.value !== "" ? parseInt(e.target.value) : "";
    setRegionId(regionId);

    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      region_id: regionId,
    }));
  };
  const updateData = async (rowData) => {
    const { id, discom_name } = rowData;
    let BASE_URL = SERVER_URL + `/api/region/region-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        discom_name,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      width: 150,
    },
    {
      headerName: "Discom Name",
      field: "discomList.discom_name",
      editable: false,
      width: 205,
    },
    {
      headerName: "Region Name",
      field: "regionList.region_name",
      editable: false,
      width: 205,
    },
    {
      headerName: "Circle Name",
      field: "circle_name",
      editable: false,
      width: 205,
    },
    {
      headerName: "size",
      field: "product_name",
      editable: false,
      width: 205,
    },
    {
      headerName: "Rate",
      field: "govt_rate",
      editable: false,
      width: 205,
    },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => deleteRow(params.data.id)}
          >
            <i className="mdi mdi-delete" />
          </button>{" "}
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => addDataToModal(params.data)}
            data-toggle="modal"
            data-target="#updateModal"
          >
            <i className="mdi mdi-note-edit-outline" />
          </button>
        </>
      ),
      minWidth: 205,
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    editable: true,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria({ circle_name: "" });
    setDiscomId("");
    setRegionId("");
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });

  const getDiscom = async () => {
    const BASE_URL = SERVER_URL + `/api/discom/all-discoms/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setDiscom(result.data);
  };

  useEffect(() => {
    getDiscom();
  }, []);
  const getRegion = async () => {
    const BASE_URL =
      SERVER_URL +
      `/api/region/drop-region-list/${user_id}?discom_id=${discomId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setRegion(result.data);
  };

  useEffect(() => {
    if (discomId) {
      getRegion();
    }
  }, [discomId]);
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Govt Circle Rate List Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add Circle & Rate
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div className="search mb-3">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control form-control-lg"
                    onChange={handleDiscomChange}
                    value={discomId}
                    id="discom"
                    required
                  >
                    <option value="">Select Discom</option>
                    {discom &&
                      discom?.length > 0 &&
                      discom?.map((item, id) => {
                        return (
                          <option
                            value={item.id}
                            key={id}
                          >{`${item.discom_name}`}</option>
                        );
                      })}
                  </select>
                </div>
              </div>
              {discomId && (
                <div className="col-md-3">
                  <div className="form-group">
                    <select
                      className="form-control form-control-lg"
                      onChange={handleRegionChange}
                      value={regionId}
                      id="region"
                      required
                    >
                      <option value="">Select Region</option>
                      {region &&
                        region?.length > 0 &&
                        region?.map((item, id) => {
                          return (
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.region_name}`}</option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              )}

              <div className="col-md-3" style={{ display: "flex" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Circle name"
                  value={filterCriteria.circle_name}
                  onChange={(e) =>
                    handleFilterChange("circle_name", e.target.value)
                  }
                />
              </div>
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                context={{ currentPage, pageSize }}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>
          <AddGovtRateList
            //   setimgfile={setimgfile}
            formRef={formRef}
            getData={getData}
          />
          <UpdateGovtRateList
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={setSelectedRowsData}
            updateHandleChange={updateHandleChange}
            getData={getData}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default GovtRateList;
